import { z } from "zod";

const mobileRule = z.string().regex(/^\d{10}$/, "Contact Number must be a valid US number");

const nonAdminSchema = z.object({
  cp_credentials: z.array(z.string()),
  email: z.string(),
  intake_practice_ids: z.array(z.string()).optional(),
  mobile: mobileRule,
  name: z.string(),
  npi_number: z.string(),
  practice: z.string(),
  provider_type: z.string(),
});

const adminSchema = nonAdminSchema.extend({
  cp_credentials: z.array(z.string()).min(1, "Credentials are required"),
  name: z.string().min(1, "Name is required"),
  npi_number: z.string().regex(/^\d{10}$/, "NPI number must be 10 digits long"),
});

export type BasicInfoFormValues = z.infer<typeof nonAdminSchema>;

export function getBasicInfoSchema(isAdmin: boolean) {
  return isAdmin ? adminSchema : nonAdminSchema;
}
